import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useHistory } from 'react-router';

const PageView = () => {
  const history = useHistory();
  useEffect(() => {
    // Initialize google analytics page view tracking
    history.listen((location) => {
      ReactGA.set({ page: location.pathname }); // Update the user's current page
      ReactGA.pageview(location.pathname); // Record a pageview for the given page
    });
  }, [history]);

  return null;
};

export default PageView;
